module.exports = __webpack_public_path__ + "img/pokeah_eynayim_yes.e0b908ac.png";